import type { ReactNode } from 'react';

import Button from '@/components/Button/Button';
import SearchInput from '@/components/Inputs/SearchInput';

type Props = {
  children?: ReactNode;
  mergeDisabled?: boolean;
  onSearchSubmit: (searchText: string) => void;
  clearSearch: () => void;
  onMergeClick: () => void;
};

export const ListHeader = (props: Props) => {
  const { onSearchSubmit, clearSearch, onMergeClick, mergeDisabled } = props;
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2">
        <SearchInput
          placeholder="Search"
          sizeType="m"
          wrapperStyle={{ width: 240 }}
          onEnter={(value) => {
            onSearchSubmit(value);
          }}
          onClickClear={() => {
            clearSearch();
          }}
        />
        {props.children}
      </div>
      <Button
        sizeType="m"
        variant="primary"
        onClick={onMergeClick}
        disabled={mergeDisabled}
      >
        Merge
      </Button>
    </div>
  );
};
